import {DatePipe} from '@angular/common';
import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {Subject} from 'rxjs';
import {take, takeUntil} from 'rxjs/operators';
import {PolicyService} from '../../../policy/services/policy.service';
import {PolicyQuery} from '../../../policy/state/policy.query';
import {AnimationOptions} from 'ngx-lottie';

declare var accounting: any;
declare var $: any;

declare function notify(): any;

@Component({
    selector: 'app-vap-edit',
    templateUrl: './vap-edit.component.html',
    styleUrls: ['./vap-edit.component.scss'],
    standalone: false
})
export class VapEditComponent implements OnInit, OnChanges {
  private unsubscribe$ = new Subject<void>();
  @Input() vap: any;
  @Input() new_session_id: any;
  @Output() dataToPass: EventEmitter<any> = new EventEmitter<any>();
  lottieOptions: AnimationOptions = {
    path: 'assets/everything-insure-loader.json',
  };
  policy: any;
  question: any;
  button = 'Add';
  selectDropdownValue = '';
  selectDropdownValueText = '';
  options: any;
  answers = '';
  valid = false;
  accounting: any;
  notify: any = notify();
  premium: any;
  price = 'R 0';
  detail = 'Add Cover';
  items: any = [];
  index = 1;
  spinner = false;
  addAnotherFlag = false;

  constructor(
    private policyQuery: PolicyQuery,
    private policiesService: PolicyService,
    public datePipe: DatePipe
  ) {
    this.policy = this.policyQuery.getActive();

  }

  ngOnInit(): void {
    accounting.settings = {
      currency: {
        symbol: 'R ', // default currency symbol is '$'
        format: '%s%v', // controls output: %s = symbol, %v = value/number (can be object: see below)
        decimal: '.', // decimal point separator
        thousand: ' ', // thousands separator
        precision: 0, // decimal places
      },
      number: {
        precision: 0, // default precision on numbers is 0
        thousand: ' ',
        decimal: '.',
      }
    };
    this.accounting = accounting;


  }

  ngOnChanges(): void {
    this.items = [];
    this.button = 'Add';
    this.policiesService.getVapQuestions(this.new_session_id, this.vap.product_vaps_id, this.policy.product_category_id).pipe(take(1))
      .subscribe(result => {
          this.question = result[0];
          this.addAnotherFlag = this.question.add_another;
          this.getItems();
          // console.log(this.question)
          this.options = JSON.parse(this.question.options);
          // console.log(this.options)
          setTimeout(() => { // wait a bit
            this.setupOptions();
          }, 100);
        },
        err => {
          // console.log(err)
        });
  }

  trackByFn(index: number, option: any): any {
    return index;
  }

  getItems(): void {
    let items: any = [];
    switch (this.question.cent_aq_question_type_id) {
      case 65:
        items = this.policy.collation.filter((item: { entry_type: string; class_id: number }) => item.entry_type === 'item' && item.class_id === 18);
        items.forEach((el: any) => {
          this.items.push({item_id: el.session_item_id, data: el, value: 0, price: 0, product_vaps_id: this.vap.product_vaps_id});
        });
        break;
      case 81:
      case 76:
      case 57:
      case 58:
      case 83:
        items = this.policy.collation.filter((item: { entry_type: string; class_id: number }) => item.entry_type === 'item' && item.class_id === 14);
        items.forEach((el: any) => {
          let p = 0;
          if (this.vap.session_item_id == el.session_item_id && this.vap.premium > 0) {
            p = this.vap.premium;
          }
          this.items.push({item_id: el.session_item_id, data: el, value: 0, price: p, product_vaps_id: this.vap.product_vaps_id});
        });
        break;
      case 72:
      case 59:
        items = this.policy.collation.filter((item: { entry_type: string; class_id: number }) => item.entry_type === 'item' && item.class_id === 10);
        items.forEach((el: any) => {
          let p = 0;
          if (this.vap.session_item_id == el.session_item_id && this.vap.premium > 0) {
            p = this.vap.premium;
          }
          this.items.push({item_id: el.session_item_id, data: el, value: 0, price: p, product_vaps_id: this.vap.product_vaps_id});
        });
        break;
      case 91:
        items = this.policy.collation.filter((item: { entry_type: string; class_id: number }) => item.entry_type === 'item' && item.class_id === 25);
        items.forEach((el: any) => {
          let p = 0;
          if (this.vap.session_item_id == el.session_item_id && this.vap.premium > 0) {
            p = this.vap.premium;
          }
          this.items.push({item_id: el.session_item_id, data: el, value: 0, price: p, product_vaps_id: this.vap.product_vaps_id});
        });
        break;
      default:
        this.items.push({item_id: this.index, data: [], price: 0, product_vaps_id: this.vap.product_vaps_id});
        break;
    }

  }

  setupOptions(): void {
    this.items.forEach((el: any) => {
      const selectId = `#dropdown-${el.item_id}`;
      $(selectId).selectmenu({
        change: (_event: any, data: any) => {
          this.selectDropdownValue = data?.item?.value;
          this.selectDropdownValueText = data?.item?.label;
          this.calculate();
        }
      });
    });

    $(`#dropdown-${this.question.cent_aq_question_id}`).selectmenu({
      change: (_event: any, data: any) => {
        // console.log(data)
        this.selectDropdownValue = data?.item?.value;
        this.selectDropdownValueText = data?.item?.label;
        this.calculate();
      }
    });

  }

  addAnother(type: number): void {
    for (let i = 0; i < this.items.length; i++) {
      if (this.items[i].item_id === this.index) {
        this.price = this.items[i].price;
      }
    }
    // console.log(type,this.price);
    if (this.stripCurrency(this.price) == '0' || this.price == undefined) {
      // console.log(this.stripCurrency(this.price));
      return;
    }
    $('.addon-expander__title.' + this.index).click();
    this.index++;

    this.items.push({item_id: this.index, data: [], value: 0, price: 0, product_vaps_id: this.vap.product_vaps_id});
    setTimeout(() => { // wait a bit
      this.setupOptions();
    }, 100);

  }

  stripCurrency(text: string): string {
    try {
      return text.replace(/ /g, '').replace('R', '');
    } catch (e) {
      return text;
    }
  }

  addItem(): void {
    this.button = '...';
    this.valid = false;
    let answers = '';
    this.spinner = true;
    this.items.forEach((el: any) => {
      switch (this.question.cent_aq_question_type_id) {
        case 81:
        case 82:
        case 76:
        case 91:
        case 58:
          answers = el.value;
          break;
        case 59:
          answers = el.percent;
          //  this.policiesService.saveAnswer(this.new_session_id, this.question.cent_aq_question_id, this.vap.class_id, el.item_id, '1|' + answers, 0).
          //    pipe(takeUntil(this.unsubscribe$))
          //    .subscribe(result => {

          //    },
          //      err => {
          //        //console.log(err)
          //      });
          break;
        case 83:
        case 70:
          answers = el.data.description_1.split('|')[0];
          break;
        case 72:
          answers = el.data.description_1.split('|')[0];
          //  if (el.added == 1) {
          //    this.policiesService.saveAnswer(this.new_session_id, this.question.cent_aq_question_id, this.vap.class_id, el.item_id, '1|' + answers, 0).
          //      pipe(takeUntil(this.unsubscribe$))
          //      .subscribe(result => {

          //      },
          //        err => {
          //          //console.log(err)
          //        });
          //  }
          break;
        case 65:
          answers = el.data.description_1;
          //  this.policiesService.saveAnswer(this.new_session_id, this.question.cent_aq_question_id, this.vap.class_id, el.item_id, '1|' + answers, 0).
          //    pipe(takeUntil(this.unsubscribe$))
          //    .subscribe(result => {

          //    },
          //      err => {
          //        //console.log(err)
          //      });
          break;
        case 67:
          answers = el.data[0] + '|' + el.data[1];
          //  this.policiesService.saveAnswer(this.new_session_id, this.question.cent_aq_question_id, this.vap.class_id, el.item_id, '1|' + answers, 0).
          //    pipe(takeUntil(this.unsubscribe$))
          //    .subscribe(result => {

          //    },
          //      err => {
          //        //console.log(err)
          //      });
          break;
        case 68:
          answers = el.data[0] + '|' + el.data[1] + '|' + el.data[2];
          //  this.policiesService.saveAnswer(this.new_session_id, this.question.cent_aq_question_id, this.vap.class_id, el.item_id, '1|' + answers, 0).
          //    pipe(takeUntil(this.unsubscribe$))
          //    .subscribe(result => {

          //    },
          //      err => {
          //        //console.log(err)
          //      });
          break;
        case 84:
          answers = el.data[0] + '|' + el.data[1] + '|' + el.data[2] + '|' + el.data[3];
          //  this.policiesService.saveAnswer(this.new_session_id, this.question.cent_aq_question_id, this.vap.class_id, el.item_id, '1|' + answers, 0).
          //    pipe(takeUntil(this.unsubscribe$))
          //    .subscribe(result => {

          //    },
          //      err => {
          //        //console.log(err)
          //      });
          break;
        case 85:
          answers = el.data[0] + '|' + el.data[1];
          break;
      }

      if (el.added == 1) {
        this.policiesService.saveAnswer(this.new_session_id, this.question.cent_aq_question_id, this.vap.class_id, el.item_id, '1|' + answers, 0).pipe(takeUntil(this.unsubscribe$))
          .subscribe(result => {

            },
            err => {
              // console.log(err)
            });
      }

    });
    this.button = 'Add';
    this.valid = true;
    $('#addons-modal').modal('hide');
    let today: any;
    today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.policiesService.collateAddons(this.new_session_id, this.policy.product_id, this.policy.group_id, this.policy.product_category_id, today).pipe(takeUntil(this.unsubscribe$))
      .subscribe(result => {
          this.policiesService.calcPremDiff(this.new_session_id, today).pipe(takeUntil(this.unsubscribe$))
            .subscribe(response => {
                // console.log(this.items)
                response.vaps = this.items;
                // console.log(response)
                this.dataToPass.emit(response);
                this.spinner = false;


              },
              err => {
                // console.log(err);
                this.spinner = false;
              });

        },
        err => {
          // console.log(err)
        });

  }

  calculate(): void {
    // console.log(this.question.cent_aq_question_type_id)
    switch (this.question.cent_aq_question_type_id) {
      case 81:
      case 76:
      case 58:
        for (let i = 0; i < this.items.length; i++) {
          if ($(`#checkbox_${this.vap.product_vaps_id}_${this.items[i].item_id}`).is(':checked')) {
            this.answers = $(`#amount_${this.vap.product_vaps_id}_${this.items[i].item_id}`).val().replace('R', '');
            this.answers = this.stripCurrency(this.answers);
            // console.log(this.answers);
            for (let i = 0; i < this.items.length; i++) {
              if (this.items[i].item_id == this.index) {
                this.items[i].value = this.answers;
              }
            }
          }
        }
        this.button = '...';
        this.answers = '0|' + this.answers;
        this.policiesService.saveAnswer(this.new_session_id, this.question.cent_aq_question_id, this.vap.class_id, this.index.toString(), this.answers, 0).pipe(takeUntil(this.unsubscribe$))
          .subscribe(result => {
              this.policiesService.getVapPremium(this.new_session_id, this.vap.product_vaps_id, this.index.toString(), this.policy.product_id, this.policy.product_category_id).pipe(takeUntil(this.unsubscribe$))
                .subscribe(result => {
                    // console.log(result)
                    this.valid = true;
                    result.forEach((el: any) => {
                      if (el.session_item_id == this.index) {
                        this.premium = el;
                      }
                    });
                    let total = 0;

                    for (let i = 0; i < this.items.length; i++) {

                      if (this.items[i].item_id == this.index) {
                        this.items[i].price = this.premium.premium;
                        this.items[i].added = 1;
                      }
                      total += this.items[i].price;
                    }
                    this.button = 'Add ' + this.accounting.formatMoney(total);
                    this.selectDropdownValue = '';
                  },
                  err => {
                    // console.log(err)
                  });
            },
            err => {
              // console.log(err)
            });
        break;
      case 59:
        for (let i = 0; i < this.items.length; i++) {
          if ($(`#checkbox_${this.vap.product_vaps_id}_${this.items[i].item_id}`).is(':checked')) {
            this.answers = $(`#percent_${this.vap.product_vaps_id}_${this.items[i].item_id}`).val().replace('%', '');
            // console.log(this.answers);
            for (let i = 0; i < this.items.length; i++) {
              if (this.items[i].item_id == this.index) {
                this.items[i].value = this.answers + '%';
                this.items[i].added = 1;
                this.items[i].added = this.question.cent_aq_question_id;
              }
            }
          }
        }
        this.button = '...';
        this.answers = '0|' + this.answers;
        this.policiesService.saveAnswer(this.new_session_id, this.question.cent_aq_question_id, this.vap.class_id, this.index.toString(), this.answers, 0).pipe(takeUntil(this.unsubscribe$))
          .subscribe(result => {
              this.policiesService.getVapPremium(this.new_session_id, this.vap.product_vaps_id, this.index.toString(), this.policy.product_id, this.policy.product_category_id).pipe(takeUntil(this.unsubscribe$))
                .subscribe(result => {
                    // console.log(result)
                    this.valid = true;
                    result.forEach((el: any) => {
                      if (el.session_item_id == this.index) {
                        this.premium = el;
                      }
                    });
                    let total = 0;

                    for (let i = 0; i < this.items.length; i++) {

                      if (this.items[i].item_id == this.index) {
                        this.items[i].price = this.premium.premium;
                      }
                      total += this.items[i].price;
                    }
                    this.button = 'Add ' + this.accounting.formatMoney(total);
                    this.selectDropdownValue = '';
                  },
                  err => {
                    // console.log(err)
                  });
            },
            err => {
              // console.log(err)
            });
        break;
      case 70:
        this.answers = '0|' + this.selectDropdownValue;
        this.policiesService.saveAnswer(this.new_session_id, this.question.cent_aq_question_id, this.vap.class_id, this.index.toString(), this.answers, 0).pipe(takeUntil(this.unsubscribe$))
          .subscribe(result => {
              this.policiesService.getVapPremium(this.new_session_id, this.vap.product_vaps_id, this.index.toString(), this.policy.product_id, this.policy.product_category_id).pipe(takeUntil(this.unsubscribe$))
                .subscribe(result => {
                    // console.log(result)
                    this.valid = true;
                    result.forEach((el: any) => {
                      if (el.session_item_id == this.index) {
                        this.premium = el;
                      }
                    });
                    let total = 0;

                    for (let i = 0; i < this.items.length; i++) {

                      if (this.items[i].item_id == this.index) {
                        this.items[i].price = this.premium.premium;
                        this.items[i].added = 1;
                        this.items[i].data = {description_1: this.selectDropdownValueText, class_id: 0};
                        this.items[i].question_id = this.question.cent_aq_question_id;
                      }
                      total += this.items[i].price;
                    }
                    this.button = 'Add ' + this.accounting.formatMoney(total);
                    this.selectDropdownValue = '';
                  },
                  err => {
                    // console.log(err)
                  });
            },
            err => {
              // console.log(err)
            });
        break;
      case 83:
      case 72:
        let total = 0;
        for (let i = 0; i < this.items.length; i++) {
          if ($(`#${this.vap.product_vaps_id}_${this.items[i].item_id}`).is(':checked')) {
            const item = this.items[i];
            item.added = 1;
            item.question_id = this.question.cent_aq_question_id;
            this.answers = this.items[i].data.description_1.split('|')[0];
            this.button = '...';
            this.answers = '0|' + this.answers;
            this.policiesService.saveAnswer(this.new_session_id, this.question.cent_aq_question_id, this.vap.class_id, this.items[i].item_id, this.answers, 0).pipe(takeUntil(this.unsubscribe$))
              .subscribe(result => {
                  this.policiesService.getVapPremium(this.new_session_id, this.vap.product_vaps_id, item.item_id, this.policy.product_id, this.policy.product_category_id).pipe(takeUntil(this.unsubscribe$))
                    .subscribe(result => {

                        this.valid = true;
                        result.forEach((el: any) => {
                          if (el.session_item_id == item.item_id) {
                            this.premium = el;
                          }
                        });
                        item.price = this.premium.premium;
                        total += item.price;
                        this.button = 'Add ' + this.accounting.formatMoney(total);
                        this.selectDropdownValue = '';
                      },
                      err => {
                        // console.log(err)
                      });
                },
                err => {
                  // console.log(err)
                });
          }
        }
        break;
      case 65:
        let amount = $(`#amount`).val();
        amount = this.stripCurrency(amount);
        if (amount == '') {
          this.valid = false;
          return;
        }
        this.answers = amount;
        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].item_id === this.index) {
            this.items[i].data = {description_1: this.accounting.formatMoney(amount), class_id: this.vap.class_id};
            this.items[i].added = 1;
            this.items[i].question_id = this.question.cent_aq_question_id;
          }
        }


        this.button = '...';
        this.answers = '0|' + this.answers;
        this.policiesService.saveAnswer(this.new_session_id, this.question.cent_aq_question_id, this.vap.class_id, this.index.toString(), this.answers, 0).pipe(takeUntil(this.unsubscribe$))
          .subscribe(result => {
              this.policiesService.getVapPremium(this.new_session_id, this.vap.product_vaps_id, this.index.toString(), this.policy.product_id, this.policy.product_category_id).pipe(takeUntil(this.unsubscribe$))
                .subscribe(result => {
                    // console.log(result)
                    this.valid = true;
                    result.forEach((el: any) => {
                      if (el.session_item_id == this.index) {
                        this.premium = el;
                      }
                    });
                    let total = 0;
                    if (this.items.length > 0) {
                      for (let i = 0; i < this.items.length; i++) {
                        if (this.items[i].item_id == this.index) {
                          this.items[i].price = this.premium.premium;
                        }
                        total += this.items[i].price;
                      }
                    } else {
                      total = this.premium.premium;
                    }
                    this.button = 'Add ' + this.accounting.formatMoney(total);

                  },
                  err => {
                    // console.log(err)
                  });
            },
            err => {
              // console.log(err)
            });
        break;
      case 67:
        let name = $(`.${this.index}.name`).val();
        let surname = $(`.${this.index}.surname`).val();
        if (name == '' || surname == '') {
          this.valid = false;
          return;
        }
        this.answers = name + '|' + surname;
        if (this.items.filter((item: { item_id: number }) => item.item_id === this.index).length > 0) {
          for (let i = 0; i < this.items.length; i++) {
            if (this.items[i].item_id === this.index) {
              this.items[i].data = {description_1: name + ' ' + surname, class_id: 0};
              this.items[i].added = 1;
              this.items[i].question_id = this.question.cent_aq_question_id;
            }
          }
        } else {
          this.items.push({item_id: this.index, data: this.answers.split('|')});
        }
        this.button = '...';
        this.answers = '0|' + this.answers;
        this.policiesService.saveAnswer(this.new_session_id, this.question.cent_aq_question_id, this.vap.class_id, this.index.toString(), this.answers, 0).pipe(takeUntil(this.unsubscribe$))
          .subscribe(result => {
              this.policiesService.getVapPremium(this.new_session_id, this.vap.product_vaps_id, this.index.toString(), this.policy.product_id, this.policy.product_category_id).pipe(takeUntil(this.unsubscribe$))
                .subscribe(result => {
                    // console.log(result)
                    this.valid = true;
                    result.forEach((el: any) => {
                      if (el.session_item_id == this.index) {
                        this.premium = el;
                      }
                    });
                    let total = 0;

                    for (let i = 0; i < this.items.length; i++) {

                      if (this.items[i].item_id == this.index) {
                        this.items[i].price = this.premium.premium;
                      }
                      total += this.items[i].price;
                    }
                    this.button = 'Add ' + this.accounting.formatMoney(total);

                  },
                  err => {
                    // console.log(err)
                  });
            },
            err => {
              // console.log(err)
            });
        break;
      case 68:
        name = $(`.name`).val();
        surname = $(`.surname`).val();
        amount = $(`.amount`).val();
        if (name === '' || surname === '' || amount === '') {
          this.valid = false;
          return;
        }
        amount = this.stripCurrency(amount);
        if (amount < this.vap.value_min || amount > this.vap.value_max) {
          this.notify.init({
            message: '<strong>Cover amount must be between ' + this.accounting.formatMoney(this.vap.value_min) + ' and ' + this.accounting.formatMoney(this.vap.value_max) + '</strong>', // required
            icon: 'info',   // default: null; options: 'info', 'complete', or any icon-name really
            size: 'lg',     // default: null; options: 'lg'
            style: 'info',  // default: null; options: 'info', 'success',
            close: true,    // default: false (close button enabled, auto-close duration removed)
            speed: 350,     // default: 350 (fade in/out speed)
            duration: 5000  // default: 5000 (duration active)
          });
          return;
        }
        try {
          this.notify.clear();
        } catch (e) {
        }
        this.answers = name + '|' + surname + '|' + amount;
        if (this.items.filter((item: { item_id: number }) => item.item_id === this.index).length > 0) {
          for (let i = 0; i < this.items.length; i++) {
            if (this.items[i].item_id === this.index) {
              this.items[i].data = {description_1: name + ' ' + surname + ' ' + this.accounting.formatMoney(amount), class_id: 0};
              this.items[i].added = 1;
              this.items[i].question_id = this.question.cent_aq_question_id;
            }
          }
        } else {
          this.items.push({item_id: this.index, data: this.answers.split('|')});
        }
        this.button = '...';
        this.answers = '0|' + this.answers;
        this.policiesService.saveAnswer(this.new_session_id, this.question.cent_aq_question_id, this.vap.class_id, this.index.toString(), this.answers, 0).pipe(takeUntil(this.unsubscribe$))
          .subscribe(result => {
              this.policiesService.getVapPremium(this.new_session_id, this.vap.product_vaps_id, this.index.toString(), this.policy.product_id, this.policy.product_category_id).pipe(takeUntil(this.unsubscribe$))
                .subscribe(result => {
                    // console.log(result)
                    this.valid = true;
                    result.forEach((el: any) => {
                      if (el.session_item_id == this.index) {
                        this.premium = el;
                      }
                    });
                    let total = 0;

                    for (let i = 0; i < this.items.length; i++) {

                      if (this.items[i].item_id == this.index) {
                        this.items[i].price = this.premium.premium;
                      }
                      total += this.items[i].price;
                    }
                    this.button = 'Add ' + this.accounting.formatMoney(total);
                    this.selectDropdownValue = '';
                  },
                  err => {
                    // console.log(err)
                  });
            },
            err => {
              // console.log(err)
            });
        break;
      case 84:
        name = $(`.${this.index}.name`).val();
        surname = $(`.${this.index}.surname`).val();
        amount = $(`.${this.index}.amount`).val();
        if (name == '' || surname == '' || amount == '' || this.selectDropdownValue == '') {
          this.valid = false;
          return;
        }
        amount = this.stripCurrency(amount);
        if (amount < this.vap.value_min || amount > this.vap.value_max) {
          this.notify.init({
            message: '<strong>Cover amount must be between ' + this.accounting.formatMoney(this.vap.value_min) + ' and ' + this.accounting.formatMoney(this.vap.value_max) + '</strong>', // required
            icon: 'info',   // default: null; options: 'info', 'complete', or any icon-name really
            size: 'lg',     // default: null; options: 'lg'
            style: 'info',  // default: null; options: 'info', 'success',
            close: true,    // default: false (close button enabled, auto-close duration removed)
            speed: 350,     // default: 350 (fade in/out speed)
            duration: 5000  // default: 5000 (duration active)
          });
          return;
        }
        try {
          this.notify.clear();
        } catch (e) {
        }
        this.answers = name + '|' + surname + '|' + this.selectDropdownValue + '|' + amount;
        if (this.items.filter((item: { item_id: number }) => item.item_id === this.index).length > 0) {
          for (let i = 0; i < this.items.length; i++) {
            if (this.items[i].item_id === this.index) {
              this.items[i].data = {description_1: name + ' ' + surname + ' ' + this.accounting.formatMoney(amount), class_id: 0};
              this.items[i].added = 1;
              this.items[i].question_id = this.question.cent_aq_question_id;
            }
          }
        } else {
          this.items.push({item_id: this.index, data: this.answers.split('|')});
        }
        this.button = '...';
        this.answers = '0|' + this.answers;
        this.policiesService.saveAnswer(this.new_session_id, this.question.cent_aq_question_id, this.vap.class_id, this.index.toString(), this.answers, 0).pipe(takeUntil(this.unsubscribe$))
          .subscribe(result => {
              this.policiesService.getVapPremium(this.new_session_id, this.vap.product_vaps_id, this.index.toString(), this.policy.product_id, this.policy.product_category_id).pipe(takeUntil(this.unsubscribe$))
                .subscribe(result => {
                    // console.log(result)
                    this.valid = true;
                    result.forEach((el: any) => {
                      if (el.session_item_id == this.index) {
                        this.premium = el;
                      }
                    });
                    let total = 0;

                    for (let i = 0; i < this.items.length; i++) {

                      if (this.items[i].item_id == this.index) {
                        this.items[i].price = this.premium.premium;
                      }
                      total += this.items[i].price;
                    }
                    this.button = 'Add ' + this.accounting.formatMoney(total);
                    this.selectDropdownValue = '';
                  },
                  err => {
                    // console.log(err)
                  });
            },
            err => {
              // console.log(err)
            });
        break;
      case 85:
        const description = $(`.description`).val();
        amount = $(`.amount`).val();
        if (description == '' || amount == '') {
          this.valid = false;
          return;
        }
        amount = this.stripCurrency(amount);
        if (amount < this.vap.value_min || amount > this.vap.value_max) {
          this.notify.init({
            message: '<strong>Cover amount must be between ' + this.accounting.formatMoney(this.vap.value_min) + ' and ' + this.accounting.formatMoney(this.vap.value_max) + '</strong>', // required
            icon: 'info',   // default: null; options: 'info', 'complete', or any icon-name really
            size: 'lg',     // default: null; options: 'lg'
            style: 'info',  // default: null; options: 'info', 'success',
            close: true,    // default: false (close button enabled, auto-close duration removed)
            speed: 350,     // default: 350 (fade in/out speed)
            duration: 5000  // default: 5000 (duration active)
          });
          return;
        }
        try {
          this.notify.clear();
        } catch (e) {
        }
        this.answers = description + '|' + amount;
        if (this.items.filter((item: { item_id: number }) => item.item_id === this.index).length > 0) {
          for (let i = 0; i < this.items.length; i++) {
            if (this.items[i].item_id === this.index) {
              this.items[i].data = {description_1: description + ' ' + this.accounting.formatMoney(amount), class_id: 0};
              this.items[i].added = 1;
              this.items[i].question_id = this.question.cent_aq_question_id;
            }
          }
        } else {
          this.items.push({item_id: this.index, data: this.answers.split('|')});
        }
        this.button = '...';
        this.answers = '0|' + this.answers;
        this.policiesService.saveAnswer(this.new_session_id, this.question.cent_aq_question_id, this.vap.class_id, this.index.toString(), this.answers, 0).pipe(takeUntil(this.unsubscribe$))
          .subscribe(result => {
              this.policiesService.getVapPremium(this.new_session_id, this.vap.product_vaps_id, this.index.toString(), this.policy.product_id, this.policy.product_category_id).pipe(takeUntil(this.unsubscribe$))
                .subscribe(result => {
                    // console.log(result)
                    this.valid = true;
                    result.forEach((el: any) => {
                      if (el.session_item_id == this.index) {
                        this.premium = el;
                      }
                    });
                    let total = 0;

                    for (let i = 0; i < this.items.length; i++) {

                      if (this.items[i].item_id == this.index) {
                        this.items[i].price = this.premium.premium;
                      }
                      total += this.items[i].price;
                    }
                    this.button = 'Add ' + this.accounting.formatMoney(total);
                    this.selectDropdownValue = '';
                  },
                  err => {
                    // console.log(err)
                  });
            },
            err => {
              // console.log(err)
            });
        break;
      case 91:
        for (let i = 0; i < this.items.length; i++) {
          if ($(`#checkbox_${this.vap.product_vaps_id}_${this.items[i].item_id}`).is(':checked')) {
            this.answers = $(`#amount_${this.vap.product_vaps_id}_${this.items[i].item_id}`).val().replace('R', '');
            this.answers = this.stripCurrency(this.answers);
            if (this.answers < this.vap.value_min || this.answers > this.vap.value_max) {
              this.notify.init({
                message: '<strong>Cover amount must be between ' + this.accounting.formatMoney(this.vap.value_min) + ' and ' + this.accounting.formatMoney(this.vap.value_max) + '</strong>', // required
                icon: 'info',   // default: null; options: 'info', 'complete', or any icon-name really
                size: 'lg',     // default: null; options: 'lg'
                style: 'info',  // default: null; options: 'info', 'success',
                close: true,    // default: false (close button enabled, auto-close duration removed)
                speed: 350,     // default: 350 (fade in/out speed)
                duration: 5000  // default: 5000 (duration active)
              });
              return;
            }
            for (let i = 0; i < this.items.length; i++) {
              if (this.items[i].item_id == this.index) {
                this.items[i].value = this.accounting.formatMoney(this.answers);
              }
            }
          }
        }
        this.button = '...';
        this.answers = '0|' + this.answers;
        this.policiesService.saveAnswer(this.new_session_id, this.question.cent_aq_question_id, this.vap.class_id, this.index.toString(), this.answers, 0).pipe(takeUntil(this.unsubscribe$))
          .subscribe(result => {
              this.policiesService.getVapPremium(this.new_session_id, this.vap.product_vaps_id, this.index.toString(), this.policy.product_id, this.policy.product_category_id).pipe(takeUntil(this.unsubscribe$))
                .subscribe(result => {
                    // console.log(result)
                    this.valid = true;
                    result.forEach((el: any) => {
                      if (el.session_item_id == this.index) {
                        this.premium = el;
                      }
                    });
                    let total = 0;

                    for (let i = 0; i < this.items.length; i++) {
                      if (this.items[i].item_id == this.index) {
                        this.items[i].price = this.premium.premium;
                        this.items[i].added = 1;
                      }
                      total += this.items[i].price;
                    }
                    this.button = 'Add ' + this.accounting.formatMoney(total);
                    this.selectDropdownValue = '';
                  },
                  err => {
                    // console.log(err)
                  });
            },
            err => {
              // console.log(err)
            });
        break;
    }

  }

  checkThis(id: number): void {
    $(`#checkbox_${this.vap.product_vaps_id}_${id}`).click();
  }

}
